import Vue from "vue";
import omit from "lodash/omit";

const getDataFromResponse = resp => {
  if (resp?.data?.success && resp?.data?.data) return resp.data.data;
  else if (resp?.status == 200 || resp?.status == 201) return resp.data;
  return resp;
};

const handleFail = e => {
  const resp = e.response;
  if (!resp) return e;

  if (resp.status == 500) {
    Vue.dialog.alert("Something went wrong when connecting the server");
  } else if (resp.status == 422) {
    Vue.dialog.alert("Please check the form for errors");
  } else if (resp.status == 400 || resp.status == 403) {
    Vue.dialog.alert(resp.data.message);
  }
};

export default class Service {
  get(url, data = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, data)
        .then(resp => {
          resolve(getDataFromResponse(resp));
        })
        .catch(e => {
          handleFail(e);
          reject(e);
        });
    });
  }

  post(url, data = null) {
    return new Promise((resolve, reject) => {
      const params = data && data.params ? data.params : data;
      axios
        .post(url, params, data ? omit(data, ["params"]) : null)
        .then(resp => {
          resolve(getDataFromResponse(resp));
        })
        .catch(e => {
          handleFail(e);
          reject(e);
        });
    });
  }

  /* Same as post(), but resolves the whole response so callers can read headers. */
  postResponse(url, data = null) {
    const params = data && data.params ? data.params : data;

    return axios
      .post(url, params, data ? omit(data, ["params"]) : null)
      .catch(e => {
        handleFail(e);
        throw e;
      });
  }

  put(url, data = {}) {
    return new Promise((resolve, reject) => {

      const params = data && data.params ? data.params : data;

      if (!params) {
        params = {};
      }

      params._method = "PUT";

      // params = data ? omit(data, ["params"]) : {};
      // params._method = 'PUT';
      axios
        .post(url, params, data ? omit(data, ["params"]) : null)
        .then(resp => {
          resolve(getDataFromResponse(resp));
        })
        .catch(e => {
          handleFail(e);
          reject(e);
        });
    });
  }

  delete(url) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, {
          _method: 'DELETE'
        })
        .then(resp => {
          resolve(getDataFromResponse(resp));
        })
        .catch(e => {
          handleFail(e);
          reject(e);
        });
    });
  }
}
